const config = {
  calendar: require('@/components/Calendar'),
}

const Tools = {
  install: (Vue) => {
    for (let i in config) {
      if (config[i].name) {
        Vue.component(config[i].name, config[i]);
      } else {
        Vue.component(config[i].default.name, config[i].default);
      }
    }
  }
}

export default Tools
